import { notification } from 'antd';
import { all, call, put, take } from 'redux-saga/effects';

//Component
import { LOAD_CASE_LIST } from '../type';
import {
  //List
  loadCaseListSuccessAction,
  loadCaseListErrorAction,
} from '../action';

import { caseService } from 'services';

function* loadCaseList() {
  while (1) {
    const action = yield take(LOAD_CASE_LIST);
    try {
      const caseList = yield call(caseService.loadCaseList, action.payload);
      yield put(loadCaseListSuccessAction(caseList));
    } catch (err) {
      yield put(loadCaseListErrorAction(err));
      notification.error({
        message: err.message,
      });
    }
  }
}

export default function* rootSaga() {
  yield all([loadCaseList()]);
}
